// ----------------------------------------------------------------------------
// Component: Testimonial
// ----------------------------------------------------------------------------
//
// A list of testimonials
//
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Pagination, A11y } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';
import './_testimonial.scss';



// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------
function handleTestimonialSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index, array) {
        slide.addEventListener('focus', function(e) {
            var slidePos = swiperEl.$el[0].getBoundingClientRect();

            // Remove standard scrolling to element in focus due to it going off the screen (slides left when it needs to stay on screen)
            swiperEl.$el[0].scrollLeft = 0;
            swiperEl.slideTo(index);

            // Emulating normal tab focus due to needing to remove standard scroll
            // If element is already in viewport, do nothing
            // Otherwise, scroll to the element and it should be in the middle of the screen when scrolling stops
            if (!(slidePos.top >=0 &&
            slidePos.left >=0 &&
            slidePos.bottom <= $(window).height() &&
            slidePos.right <= $(window).width())) {
                window.scrollTo({
                    top: (slidePos.top + window.scrollY) - ($(window).height() / 2),
                    left: 0,
                    behavior: 'smooth'
                });
            }

        })
    });
}




$(function() {
    $(".carousel--testimonial-slider").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each collection list slider
        $this.addClass("testimonial-slider-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.testimonial-slider').find(".swiper-button-prev").addClass("testimonial-slider-btn-prev-" + index);
        $this.parents('.testimonial-slider').find(".swiper-button-next").addClass("testimonial-slider-btn-next-" + index);

        var swiper = new Swiper(".testimonial-slider-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Pagination, A11y],
            slidesPerView: 1,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

            // // Navigation arrows
            navigation: {
              nextEl: ".testimonial-slider-btn-next-" + index,
              prevEl: ".testimonial-slider-btn-prev-" + index
            },

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: 'true'
            },
        });

        swiper.slides.forEach(function(slide, index) {
            let slideLink = slide.querySelector('a');
            slideLink.addEventListener('focus', function(e) {
                swiper.slideTo(index);
            })
        });
    });
});